/** Nombre accesible de la barra flotante de compra. */
export const BUY_BOX_LABEL = 'Compra de entradas'

/**
 * `module_name` del `click` del enlace al recinto de la barra de compra.
 * Se aplica por criterio transversal la fila "Click en (Localización)" de
 * `Ubicación Detalles Producto.csv` (`venue_location`): no hay ficha propia de
 * la barra de compra.
 */
export const BUY_BOX_VENUE_MODULE_NAME = 'venue_location'
